import {
  AfterViewInit,
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  TemplateRef,
  ViewChild,
} from '@angular/core';

@Component({
  selector: 'app-ngx-loading',
  templateUrl: './custom-ngx-loading.component.html',
  styleUrls: ['./custom-ngx-loading.component.css'],
})
export class CustomNgxLoadingComponent implements OnInit, AfterViewInit, OnChanges {
  @Input() show = false;

  @ViewChild('customLoadingTemplate')
  customLoadingTemplate: TemplateRef<any>;
  @Input() text = 'PLEASE_WAIT';
  @Input() showText = true;
  @Input() size = null;
  @Input() progress: boolean;
  @Input() progressValue = 0;

  constructor() {}

  ngOnInit() {}

  ngAfterViewInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.progressValue) {
      this.progressValue = changes.progressValue.currentValue;
    }
  }
}
